import * as Routes from 'constants/Routes'

export default () => ({
  path: Routes.TERMS,
  getComponent: async function (nextState, cb) {
    const module = await import('./TermsContainer')
    cb(null, module.default)
  }
})
